import { post, get, internalDestroy, put } from './index';

export const exportExperience = ({
  experienceId,
  locale,
  exportFormat,
  options,
}) => {
  return post(
    `experiences/${experienceId}/export/${exportFormat}?locale=${
      locale ?? 'en'
    }`,
    options,
    { responseType: 'blob' },
    false,
  );
};

export const exportExperiencesCompatibilities = ({ filters }) => {
  return post(
    'experiences/export/experiencesCompatibilities',
    filters,
    {
      responseType: 'blob',
    },
    false,
  );
};

export const getExperiences = async ({ filters, locale, skip = false }) => {
  if (skip) {
    return Promise.resolve(null);
  }

  return await post(`/experiences/liste?locale=${locale ?? 'en'}`, filters);
};

export const getExperience = ({ experienceId, tripId, locale = 'en' }) => {
  if (!experienceId) {
    return Promise.resolve(null);
  }

  const params = new URLSearchParams({
    ...(locale && { locale }),
    ...(tripId && { tripId }),
  });

  return get(`/experiences/${experienceId}?${params.toString()}`);
};

export const updateExperience = async ({ experienceId, payload, locale }) => {
  return await put(
    `/experiences/${experienceId}?locale=${locale ?? 'en'}`,
    payload,
  );
};

export const archiveExperience = ({ experienceIds }) => {
  return internalDestroy(`/experiences`, experienceIds);
};

export const duplicateExperience = async (id) => {
  return await post(`/experiences/${id}/duplicate`);
};

export const editCancellationConditionsToExperiences = async (
  organizationId,
  payload,
) => {
  return await put(
    `/experiences/organizations/${organizationId}/cancellation-conditions/bulk`,
    payload,
  );
};

export const applyDynamicCancellationConditions = ({ organizationId }) => {
  if (!organizationId) {
    return Promise.reject(new Error('Organization ID is required'));
  }

  return post(
    `/experiences/organizations/${organizationId}/dynamic-cancellation-conditions/bulk`,
  );
};

export const getExperienceCancelConditions = async ({ experienceId }) => {
  if (!experienceId) {
    return Promise.resolve(null);
  }

  return await get(`/experiences/${experienceId}/cancel-conditions`);
};

export const saveExperienceCancelConditions = async ({
  experienceId,
  payload,
}) => {
  return await put(`/experiences/${experienceId}/cancel-conditions`, {
    conditions: payload,
  });
};
